import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";
import { ColorMap } from "@/lib/shaders/colormaps";

export const useUserSettingsStore = create<{
  colormap: ColorMap;
  glassEffectEnabled: boolean;
  meshColor: string;
  wireframeEnabled: boolean;
  useLitMaterial: boolean;
  meshRoughness: number;
  meshMetalness: number;
  meshOpacity: number;
  setColormap: (colormap: ColorMap) => void;
  setGlassEffectEnabled: (enabled: boolean) => void;
  setMeshColor: (color: string) => void;
  setWireframeEnabled: (enabled: boolean) => void;
  setUseLitMaterial: (useLit: boolean) => void;
  setMeshRoughness: (roughness: number) => void;
  setMeshMetalness: (metalness: number) => void;
  setMeshOpacity: (opacity: number) => void;
}>()(
  devtools(
    persist(
      (set) => ({
        colormap: ColorMap.TURBO,
        glassEffectEnabled: false,
        meshColor: "#b0b0b0",
        wireframeEnabled: false,
        useLitMaterial: true,
        meshRoughness: 0.5,
        meshMetalness: 0.65,
        meshOpacity: 0.5,
        setColormap: (colormap) => set({ colormap }),
        setGlassEffectEnabled: (enabled) => set({ glassEffectEnabled: enabled }),
        setMeshColor: (color) => set({ meshColor: color }),
        setWireframeEnabled: (enabled) => set({ wireframeEnabled: enabled }),
        setUseLitMaterial: (useLit) => set({ useLitMaterial: useLit }),
        setMeshRoughness: (roughness) => set({ meshRoughness: roughness }),
        setMeshMetalness: (metalness) => set({ meshMetalness: metalness }),
        setMeshOpacity: (opacity) => set({ meshOpacity: opacity }),
      }),
      {
        name: "user-settings-storage",
        storage: createJSONStorage(() =>
          process.env.VITEST
            ? { getItem: () => null, setItem: () => {}, removeItem: () => {} }
            : localStorage
        ),
      }
    ),
    { name: "UserSettingsStore", trace: process.env.NODE_ENV === "development" }
  )
);
